import { ReactNode } from 'react';

import { Portal } from '@dreryk/react-components';

import { StyledCalendarSidePanelPortalContainer } from './CalendarSidePanel.styled';

type CalendarSidePanelPlacement = 'selectors' | 'miniCalendar' | 'underMiniCalendar';

const getCalendarSidePanelPlacementId = (placement: CalendarSidePanelPlacement): string => {
   return `calendarSidePanel-${placement}`;
};

type CalendarSidePanelPortalContainerProps = {
   readonly children?: ReactNode;
   readonly placement: CalendarSidePanelPlacement;
};

export const CalendarSidePanelPortalContainer = (props: CalendarSidePanelPortalContainerProps): JSX.Element => {
   return (
      <StyledCalendarSidePanelPortalContainer
         id={getCalendarSidePanelPlacementId(props.placement)}
         testId={getCalendarSidePanelPlacementId(props.placement)}
      >
         {props.children}
      </StyledCalendarSidePanelPortalContainer>
   );
};

type CalendarSidePanelPortalProps = {
   readonly children: ReactNode;
   readonly placement: CalendarSidePanelPlacement;
};

export const CalendarSidePanelPortal = (props: CalendarSidePanelPortalProps): JSX.Element => {
   return <Portal containerId={getCalendarSidePanelPlacementId(props.placement)}>{props.children}</Portal>;
};
